export default "__VITE_ASSET__b691fe7b__"